import React, { useState } from 'react';
import { Card } from '../ui';
import { sampleConvenienceFee } from '../../data/marketing';

// Sample revenue estimator. EXAMPLE NUMBERS ONLY - not a quote, no competitor
// comparison. Uses the sample tiered convenience-fee model.
const usd = (n) => `$${Math.round(n).toLocaleString('en-US')}`;

const CostCalculator = () => {
  const [tickets, setTickets] = useState(10000);
  const [price, setPrice] = useState(7);

  const faceValue = tickets * price;            // school keeps 100%
  const feePer = sampleConvenienceFee(price);   // null = custom tier
  const totalFees = feePer == null ? null : tickets * feePer;

  return (
    <Card className="mt-12 p-6 sm:p-8 max-w-4xl mx-auto">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-1">
        <h3 className="text-xl font-bold font-display text-ink-900">Sample revenue estimator</h3>
        <span className="text-[11px] font-semibold uppercase tracking-wide text-amber-700 bg-amber-50 ring-1 ring-amber-200 rounded-full px-2.5 py-1">
          Illustrative · not a quote
        </span>
      </div>
      <p className="text-sm text-ink-500 mb-6">Estimate with your own numbers. Figures use the sample fee model above and are illustrative.</p>

      {/* Inputs */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <div className="flex items-baseline justify-between">
            <label className="text-sm font-medium text-ink-700">Tickets sold / year</label>
            <span className="font-bold font-display text-ink-900">{tickets.toLocaleString()}</span>
          </div>
          <input type="range" min="500" max="100000" step="500" value={tickets}
            onChange={(e) => setTickets(Number(e.target.value))} className="w-full mt-2 accent-brand-600" />
        </div>
        <div>
          <div className="flex items-baseline justify-between">
            <label className="text-sm font-medium text-ink-700">Avg ticket price</label>
            <span className="font-bold font-display text-ink-900">${price}</span>
          </div>
          <input type="range" min="1" max="60" step="1" value={price}
            onChange={(e) => setPrice(Number(e.target.value))} className="w-full mt-2 accent-brand-600" />
        </div>
      </div>

      {/* Result */}
      <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="rounded-2xl bg-brand-50 p-5">
          <p className="text-sm text-brand-700 font-medium">Your district keeps</p>
          <p className="text-2xl font-bold font-display text-brand-800 mt-1">{usd(faceValue)}</p>
          <p className="text-xs text-ink-500 mt-1">100% of ticket revenue.</p>
        </div>
        <div className="rounded-2xl bg-emerald-50 p-5">
          <p className="text-sm text-emerald-700 font-medium">Sample convenience fee / ticket</p>
          <p className="text-2xl font-bold font-display text-emerald-700 mt-1">{feePer == null ? 'Custom' : `$${feePer.toFixed(2)}`}</p>
          <p className="text-xs text-ink-500 mt-1">Paid by attendees, not the school.</p>
        </div>
        <div className="rounded-2xl bg-ink-50 p-5">
          <p className="text-sm text-ink-600 font-medium">Example attendee fees (total)</p>
          <p className="text-2xl font-bold font-display text-ink-900 mt-1">{totalFees == null ? 'Custom' : usd(totalFees)}</p>
          <p className="text-xs text-ink-500 mt-1">+ payment processing, also attendee-paid.</p>
        </div>
      </div>

      <p className="text-xs text-ink-400 mt-6 leading-relaxed">
        Illustrative figures based on the sample fee model above — not a quote, not final pricing, and not a binding offer.
        Schools keep 100% of ticket revenue; convenience and payment processing fees are paid by attendees. Your district's
        pricing is confirmed together during a demo.
      </p>
    </Card>
  );
};

export default CostCalculator;
